import { render, staticRenderFns } from "./PoliciesPrivacy.vue?vue&type=template&id=7f2e0fe2&scoped=true&"
var script = {}
import style0 from "./PoliciesPrivacy.vue?vue&type=style&index=0&id=7f2e0fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e0fe2",
  null
  
)

export default component.exports